import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const DataDisclosureTextModal = (props) => {
  const handleClose = () => props.setShow(false);
  const handleShow = () => props.setShow(true);

  return (
    <>
      <Modal
        show={props.show}
        onHide={handleClose}
        size="lg"
        className="data-disclosure-text"
      >
        <Modal.Body className="p-4">
          <h6>
            KİŞİSEL VERİLERİNİZE DAİR HAKLARINIZ VE AYDINLATMA METNİ TOPLANAN
            KİŞİSEL VERİLERİNİZLE İLGİLİ HAKLARINIZ
          </h6>
          <p>
            Veri sahibi, işlenen Kişisel Verileri’nin neler olduğunu ve işlenip
            işlenmediğini, işleme amacı doğrultusunda kullanılıp
            kullanılmadığını öğrenebilir, verileri işlenmişse bu hususta bilgi
            talep edebilir, yurt içi veya yurt dışında Kişisel Veriler’in
            aktarıldığı üçüncü kişileri öğrenebilir, eksik veya yanlış işlenen
            Kişisel Veriler söz konusu ise veya işlenen Kişisel Verileri’nde
            herhangi bir değişiklik olması durumunda bu verilerin
            düzeltilmesini, değiştirilmesini, güncellenmesini, KVKK’nın 7.
            maddesinde öngörülen şartlar çerçevesinde silinmesini/yok edilmesini
            veya anonim hale getirilmesini, bu işlemlerin (eksik veya yanlış
            işlenen Kişisel Verileri söz konusu ise, bu verilerin düzeltilmesini
            veya KVKK’nın 7. maddesinde öngörülen şartlar çerçevesinde
            silinmesini/yok edilmesini veya anonim hale getirilmesini) Kişisel
            Veriler’in aktarıldığı üçüncü kişilere bildirilmesini talep
            edebilir; işlenen verilerin münhasıran otomatik sistemler ile analiz
            edilmesi nedeniyle aleyhine bir sonucun ortaya çıkmasına itiraz
            edebilir ve Kişisel Veriler’in kanuna aykırı olarak işlenmesi
            sebebiyle zarara uğraması hâlinde zararın giderilmesini talep
            edebilir. Kullanıcı/Üye, bu kapsamdaki haklarını KVKK md. 11
            uyarınca:
            <br />
            <br />• Pinaps’ın hakkınızda kişisel veri işleyip işlemediğini
            öğrenmek, eğer işlemişse, buna ilişkin bilgi talep etmek, <br />
            <br />• Kişisel verilerinizin işlenme amacını ve bunların amacına
            uygun kullanılıp kullanılmadığı öğrenmek, <br />
            <br />• Kişisel verilerin yurtiçi veya yurtdışına aktarılıp
            aktarılmadığı ve kimlere aktarıldığını öğrenmek haklarına
            sahipsiniz. <br />
            <br />• Ayrıca, Pinaps’tan yanlış ve eksik kişisel verilerinizin
            düzeltilmesini ve verilerinin aktarıldığı veya aktarılmış
            olabileceği alıcıların bilgilendirilmesini talep etme hakkınız
            vardır.
            <br />
            <br />
            Kişisel verilerinizin KVKK madde 7’de öngörülen şartlar çerçevesinde
            verilerinizin imha edilmesini (silinmesini, yok edilmesini veya
            anonim hale getirilmesini) Pinaps’tan talep edebilirsiniz. Aynı
            zamanda verilerin aktarıldığı veya aktarılabileceği 3. kişilerin söz
            konusu imha talebiniz ile ilgili bilgilendirilmesini talep
            edebilirsiniz. Ancak imha talebinizi değerlendirerek hangi yöntemin
            uygun olduğu somut olayın koşullarına göre tarafımızca
            değerlendirilecektir. Bu bağlamda seçtiğimiz imha yöntemini neden
            seçtiğimiz ile ilgili bizden her zaman bilgi talep edebilirsiniz.
            <br />
            <br />
            Münhasıran bir otomatik sistem kullanılarak oluşturulmuş kişisel
            veri analizinizin sonuçlarına bu sonuçlar çıkarlarınıza aykırıysa
            itiraz edebilirsiniz.
            <br />
            <br />
            Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle
            zarara uğramanız halinde zararın giderilmesini talep edebilirsiniz.
            <br />
            <br />
            Başvurunuzda yer alan talepleriniz, talebin niteliğine göre en geç
            otuz gün içinde ücretsiz olarak sonuçlandırılacaktır. Ancak, işlemin
            Pinaps için ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel
            Verileri Koruma Kurulu tarafından Veri Sorumlusuna Başvuru Usul ve
            Esasları Hakkında Tebliğ’de belirlenen tarifedeki ücret alınabilir.
            <br />
            <br />
            Kişisel verilerinizin işlenmesi ile ilgili hususlarda başvurunuzu,
            bu Aydınlatma Metni’ nin ekinde yer alan başvuru formunu doldurarak,
            yazılı olarak veya kayıtlı elektronik posta (KEP) adresi, güvenli
            elektronik imza, mobil imza ya da bize daha önce bildirdiğiniz ve
            kayıtlarımızda yer alan elektronik posta adresinizi kullanmak
            suretiyle Pinaps’a teslim etmeniz gerekmektedir. Pinaps tarafından
            talebinizin mahiyetine ve başvuru yönteminize göre Pinaps tarafından
            başvurunun size ait olup olmadığının belirlenmesi ve böylece
            haklarınızı koruyabilmek amacıyla ek doğrulamalar (kayıtlı
            telefonunuza mesaj gönderilmesi, aranmanız gibi) istenebilir.
            Örneğin Pinaps’ta kayıtlı olan e-posta adresiniz aracılığıyla
            başvuru yapmanız halinde Pinaps’ta kayıtlı başka bir iletişim
            yöntemini kullanarak size ulaşabilir ve başvurunun size ait olup
            olmadığının teyidini isteyebiliriz.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default DataDisclosureTextModal;
